import { getContext } from '@fiverr-private/fiverr_context';
import { VARIANTS } from './constants';

export * from './constants';

/**
 * Returns whether the user is allocated to the experiment
 *
 * @param {number} experimentId - The experiment id to check.
 * @returns {boolean}
 */
export const inExperiment = (experimentId) => {
    const variant = getVariant(experimentId);

    return variant >= VARIANTS.B;
};

/**
 * Returns the experiment variant allocation by id.
 *
 * @param {number} experimentId - The experiment id to check.
 * @returns {number}
 */
export const getVariant = (experimentId) => {
    const { abTests = {} } = getContext();

    const variant = abTests[experimentId];

    return transformVariant(variant);
};

/**
 * Transforms the variant to one of the supported variants.
 *
 * @param {string | number} variant - The variant to transform.
 * @returns {number}
 */
const transformVariant = (variant) => {
    switch (Number(variant)) {
        case 1:
            return VARIANTS.A;
        case 2:
            return VARIANTS.B;
        case 3:
            return VARIANTS.C;
        default:
            return VARIANTS.A;
    }
};
